<template>
  <div>
    <!-- Search Icon -->
    <span v-show="!isExpanded" @click="toggleSearch" class="outer-search-icon">
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="25" height="25" viewBox="0 0 48 48">
        <path d="M 20.5 6 C 12.515556 6 6 12.515562 6 20.5 C 6 28.484438 12.515556 35 20.5 35 C 23.773158 35 26.788919 33.893018 29.220703 32.050781 L 38.585938 41.414062 A 2.0002 2.0002 0 1 0 41.414062 38.585938 L 32.050781 29.220703 C 33.893017 26.788918 35 23.773156 35 20.5 C 35 12.515562 28.484444 6 20.5 6 z M 20.5 10 C 26.322685 10 31 14.677319 31 20.5 C 31 23.295711 29.914065 25.820601 28.148438 27.697266 A 2.0002 2.0002 0 0 0 27.701172 28.144531 C 25.824103 29.912403 23.29771 31 20.5 31 C 14.677315 31 10 26.322681 10 20.5 C 10 14.677319 14.677315 10 20.5 10 z"></path>
      </svg>
    </span>
    <!-- Expanded Bar -->
    <transition name = "expand">
      <div v-show="isExpanded" class="search-container">
        <span class="inner-search-icon">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
            <path d="M 20.5 6 C 12.515556 6 6 12.515562 6 20.5 C 6 28.484438 12.515556 35 20.5 35 C 23.773158 35 26.788919 33.893018 29.220703 32.050781 L 38.585938 41.414062 A 2.0002 2.0002 0 1 0 41.414062 38.585938 L 32.050781 29.220703 C 33.893017 26.788918 35 23.773156 35 20.5 C 35 12.515562 28.484444 6 20.5 6 z M 20.5 10 C 26.322685 10 31 14.677319 31 20.5 C 31 23.295711 29.914065 25.820601 28.148438 27.697266 A 2.0002 2.0002 0 0 0 27.701172 28.144531 C 25.824103 29.912403 23.29771 31 20.5 31 C 14.677315 31 10 26.322681 10 20.5 C 10 14.677319 14.677315 10 20.5 10 z"></path>
          </svg>
        </span>
        <!-- Input Box -->
        <input type="text" class="search-input" placeholder="Search..." v-model="searchQuery" @input="onSearchInput"/>
        <button class="search-button"></button>
        <!-- Close Search Bar -->
        <button @click="toggleSearch" class="x-button">x</button>
        </div>
    </transition>
  </div>
</template>

<script>
import EventBus from '@/eventbus.js';
export default {
  name: "SearchBar",
  data(){
    return {
        isExpanded: false,
        searchQuery: "",
    }
  },
  methods: {
    toggleSearch(){
        this.isExpanded = !this.isExpanded;
    },
    onSearchInput() {
      // Emit the search query to the event bus
      EventBus.$emit('updateFilteredVideos', this.searchQuery);
    },
  }
};
</script>
  
<style scoped>

.search-container {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 300px;
  border: 2px solid black;
  /* border: 2px solid #ccc; */
  border-radius: 10px;
  background: white;
  height: 30px;
}

.search-input {
  border: none;
  outline: none;
  flex: 1;
  padding: 8px 12px;
  font-size: 14px;
  border-radius: 25px;
  background: transparent;
}
  
.search-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  font-size: 18px;
}

.outer-search-icon{
  cursor: pointer;
  display: flex;
  align-items: center;
}

.inner-search-icon{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
}

.x-button{
  background: none;
  border: none;
  font-weight: 600;
  /* border: 2px solid #ccc;
  border-radius: 0 10px 10px 0; 
  border-right: none; */
}

/* transition for opening search bar */
.expand-enter-active {
  transition: width 0.4s ease-in-out, opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
}

.expand-enter, .expand-leave-to {
  width: 0;
  opacity: 0;
  transform: translateX(20px); 
}

</style>
  